import { useQuery } from 'react-query';

import { getAccount } from 'catering/api/resources/account';
import { selectFlattenedAccount } from 'catering/hooks/query/account/selectors';

export const ACCOUNT_QUERY_KEY = 'account';

const DEFAULT_QUERY_OPTIONS = {
  initialData: window.bentoboxBaseOrdering?.account,
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
  useErrorBoundary: false
};

export function useAccount() {
  return useQuery(ACCOUNT_QUERY_KEY, getAccount, {
    ...DEFAULT_QUERY_OPTIONS,
    select: account => selectFlattenedAccount(account)
  });
}

export * from 'catering/hooks/query/account/selectors';
